import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import TermsOfService from './TermsOfServiceBox';
import ConfidentialAgreement from './ConfidentialAgreementBox';

const Register = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState("");
  const [acceptedTOS, setAcceptedTOS] = useState(false);
  const [acceptedCA, setAcceptedCA] = useState(false);
  const { register } = useContext(AuthContext);
  const navigate = useNavigate(); // Initialize the navigate hook

  const handleAcceptTOS = async () => {
    setAcceptedTOS(true);
  };
  const handleAcceptCA = async () => {
    setAcceptedCA(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if(!acceptedTOS) {
      setError("Please read and accept Terms of Service.");
      return;
    }

    if(!acceptedCA) {
      setError("Please read and accept Confidential Agreement.");
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const passwordValidation = /^(?=.*[A-Z])(?=.*\d).{6,}$/;
    if (!passwordValidation.test(password)) {
      setError('Password must be at least 6 characters long and include at least one capital letter and one number');
      return;
    }

    try {
      await register(username, email, password, acceptedTOS, acceptedCA);
      setSuccess("Success! Your account is pending approval by an administrator.");
      setTimeout(() => {
        navigate('/');
      }, 10000); // after 10s go back to home page.
    } catch (error) {
      setError(error.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Register</h1>
      <p style={styles.blurb}>Please fill out these fields to register.</p>
      <form onSubmit={handleSubmit} style={styles.form}>
        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}
        {!success && (<>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            style={styles.input}
            autocomplete="off"
            required
          />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            style={styles.input}
            autocomplete="off"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autocomplete="off"
            style={styles.input}
            required
          />
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm Password"
            autocomplete="off"
            style={styles.input}
            required
          />
          <TermsOfService onAccept={handleAcceptTOS} />
          <ConfidentialAgreement onAccept={handleAcceptCA} />
          <button type="submit" style={styles.button}>Register</button>
        </>)}
      </form>
      <p style={styles.link}>
        Already registered? <Link to="/login">Sign in here</Link>
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '50px auto 0',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  heading: {
    textAlign: 'center',
    marginBottom: '10px',
  },
  blurb: {
    textAlign: 'center',
    marginBottom: '20px',
    color: '#555',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    borderRadius: '5px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  button: {
    padding: '10px',
    margin: '10px 0',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#007bff',
    color: '#fff',
    cursor: 'pointer',
  },
  error: {
    color: 'red',
    marginBottom: '10px',
  },
  success: {
    color: 'green',
    marginBottom: '10px',
  },
  link: {
    textAlign: 'center',
    marginTop: '10px',
  },
};

export default Register;
